import type { CSSObject } from '@mui/material/styles'

/**
 * Native scrollbar rules that mirror `react-perfect-scrollbar`'s appearance
 * (thin gray thumb, transparent track) so the page-level scrollbar and any
 * Dialog/Modal scrollbars don't fall back to the heavier OS default.
 *
 * Use as a CSS object — either spread into a `styled(...)` definition or
 * under an `sx` prop.
 */
export const scrollbarStyles: CSSObject = {
	scrollbarWidth: 'thin',
	scrollbarColor: '#aaa transparent',
	'&::-webkit-scrollbar': { width: 15, height: 15 },
	'&::-webkit-scrollbar-track': { background: 'transparent' },
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#aaa',
		borderRadius: 6,
		border: '4.5px solid transparent',
		backgroundClip: 'content-box'
	},
	'&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#999' }
}
